module.exports = __webpack_public_path__ + "img/vivo-icon.acc29e9b.svg";